/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeIcon16Regular = forwardRef('SearchLoupeIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.853 11.914a6.25 6.25 0 1 1 1.06-1.06l2.854 2.853a.75.75 0 1 1-1.06 1.06l-2.854-2.853ZM2.246 6.996a4.75 4.75 0 1 1 8.153 3.313.784.784 0 0 0-.09.09 4.75 4.75 0 0 1-8.064-3.403Z" })));
});
